let counter = 0;

export function nextSequence(): number {
  counter += 1;
  return counter;
}

export function resetSequence() {
  counter = 0;
}
